<div mat-dialog-content class="app-mat-dialog-content">
    <ng-content></ng-content>
</div>
